import { getCombinedMatchedMetadataFromLabels } from '@modules/feedback/components/FeedbackDetails/utils/getCombinedMatchedMetadataFromLabels';
import { Highlight, PredictionLabelType } from '@modules/feedback/types';
import { PredictionHighlights } from '@modules/feedbackV2/expanded/types';
import { FeedbackLabel } from 'v2/core/entities/feedback';

const getAllHighlights = (labels: FeedbackLabel[]): PredictionHighlights => {
  const allUnits = getCombinedMatchedMetadataFromLabels(labels);

  const allHighlightUnits = allUnits.map((unit) => {
    return {
      ...unit,
      msgIDx: unit.msgIDx ?? 0,
    };
  });

  const obj: Record<string, Highlight[]> = {};

  allHighlightUnits
    .filter((highlightUnit) => {
      const isKeywordSummary = highlightUnit.type === 'KEYWORD_SUMMARY';
      const isSentimentLabelType =
        highlightUnit.labelType === PredictionLabelType.Sentiment;

      return !isKeywordSummary && !isSentimentLabelType;
    })
    .forEach((highlightUnit) => {
      const highlightProp: Highlight = {
        ...highlightUnit,
      };

      if (highlightProp.startIDx - highlightProp.endIDx === 0) {
        return;
      }

      if (highlightUnit.msgIDx.toString() in obj) {
        obj[highlightUnit.msgIDx].push(highlightProp);
      } else {
        obj[highlightUnit.msgIDx] = [highlightProp];
      }
    });

  return obj;
};

export default getAllHighlights;
